import { toast } from 'react-toastify';

export const copyToClipboard = async (value: string): Promise<void> => {
  try {
    await navigator.clipboard.writeText(value);
    toast.success(`Copied ${value}`);
  } catch {
    toast.error('Could not copy to clipboard');
  }
};
